import { Button, ButtonProps, useDisclosure } from "@chakra-ui/react";
import RemoveAccessModal from "./RemoveAccessModal";

type RemoveAccessButtonProps = Readonly<
  {
    userId: string;
  } & ButtonProps
>;

const RemoveAccessButton = ({
  userId,
  ...buttonProps
}: RemoveAccessButtonProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button variant="destructive" size="md" onClick={onOpen} {...buttonProps}>
        Remove Access
      </Button>

      <RemoveAccessModal userId={userId} isOpen={isOpen} onClose={onClose} />
    </>
  );
};

export default RemoveAccessButton;
